<div class="p-6">
  <h2 class="text-xl font-semibold mb-4 text-white">{{ 'ADMINISTRATION_AVANCEE.CONVERSION.TITLE' | translate }}</h2>

  <div class="mb-6">
    <p class="text-sm text-gray-300 mb-4">
      {{ 'ADMINISTRATION_AVANCEE.CONVERSION.DESCRIPTION' | translate }}
    </p>

    <mat-form-field class="w-full mb-4">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.CONVERSION.EMAILS_LABEL' | translate }}</mat-label>
      <textarea
        matInput
        [(ngModel)]="emailInput"
        rows="8">
      </textarea>
      <mat-hint>{{ 'ADMINISTRATION_AVANCEE.CONVERSION.EMAILS_HINT' | translate }}</mat-hint>
    </mat-form-field>

    @if (emails.length > 0) {
      <div class="mb-4">
        <p class="text-sm font-semibold text-gray-300">
          {{ emails.length }} {{ 'ADMINISTRATION_AVANCEE.CONVERSION.EMAILS_COUNT' | translate }}
        </p>
      </div>
    }

    <mat-form-field class="w-full mb-4">
      <mat-label>{{ 'ADMINISTRATION_AVANCEE.CONVERSION.PASSWORD_LABEL' | translate }}</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="motDePasse">
        <mat-hint>{{ 'ADMINISTRATION_AVANCEE.CONVERSION.PASSWORD_HINT' | translate }}</mat-hint>
      </mat-form-field>

      <div class="flex items-center gap-4">
        <button
          mat-raised-button
          (click)="convertir()"
          [disabled]="isLoading || emails.length === 0 || !motDePasse"
          class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">
          @if (!isLoading) {
            <mat-icon>transform</mat-icon>
          }
          @if (isLoading) {
            <mat-spinner diameter="20" class="inline-block mr-2"></mat-spinner>
          }
          {{ 'ADMINISTRATION_AVANCEE.CONVERSION.CONVERT_BUTTON' | translate }}
        </button>
      </div>
    </div>
  </div>
